module.exports = __webpack_public_path__ + "media/applicants/device_signup_6-au-5494548a.jpg";